import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { welcomeTranslations } from "../../translations/welcomeTranslations";

const CoconSacreHero = () => {
  const { language } = useLanguage();
  const t = (obj) => obj[language] || obj['fr'];
  const tr = welcomeTranslations;

  return (
    <>
      {/* Back to Home - cached */}
      <header className="absolute top-6 left-6 z-20">
        <Link 
          to="/"
          className="inline-flex items-center gap-2 text-[#4B3329]/40 bg-[#F9F7F2]/80 backdrop-blur-sm px-4 py-2 rounded-full hover:text-[#4B3329] transition-colors"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
          <span className="text-sm tracking-wide">{t(tr.nav.backToHome)}</span>
        </Link>
        {/* ═══ CONSERVATION TEMPORAIRE — tooltip "sera disponible" ═══
        <div className="absolute left-0 top-full mt-2 px-4 py-2 bg-[#3F2A24] text-[#F3E5CF] text-xs rounded-lg shadow-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10">
          {language === 'en' ? 'This page will be available on April 1, 2026.' : 'Cette page sera disponible le 1er avril 2026'}
        </div>
        ═══ FIN CONSERVATION TEMPORAIRE ═══ */}
      </header>

      {/* Hero Section - PREMIUM Typography */}
      <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ 
            backgroundImage: `url(https://customer-assets.emergentagent.com/job_site-cocoon/artifacts/pqhu48oe_532322ee702dfc8f7c41e44102406950.jpg)`,
            backgroundPosition: '50% 50%'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#3F2A24]/40 via-[#3F2A24]/30 to-transparent" />

        {/* Content - PREMIUM vertical hierarchy */}
        <div className="relative z-10 text-center px-6 max-w-2xl mx-auto" style={{ marginTop: '2rem' }}>
          {/* Subtitle - refined spacing */}
          <p 
            className="text-xs md:text-sm uppercase font-medium text-[#F3E5CF]/85 mb-4"
            style={{ letterSpacing: '0.35em' }}
          >
            {t(tr.hero.subtitle)}
          </p>
          
          {/* Title - PREMIUM letter-spacing for elegance */}
          <h1 
            className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-[#F3E5CF] mb-8"
            style={{ 
              letterSpacing: '0.06em',
              lineHeight: '1.1'
            }}
          >
            {t(tr.hero.title)}
          </h1>
          
          {/* Tagline - balanced middle dots */}
          <p 
            className="text-[#F3E5CF] text-lg md:text-xl font-light mb-10"
            style={{ letterSpacing: '0.18em' }}
          >
            {t(tr.hero.tagline)}
          </p>
          
          {/* Hero phrase - contemplative rhythm */}
          <p 
            className="text-[#F3E5CF]/75 text-sm md:text-base italic max-w-md mx-auto mb-12"
            style={{ lineHeight: '2.1', textWrap: 'balance' }}
          >
            {t(tr.hero.heroPhrase)}
          </p>
          
          {/* Location - medium emphasis, optical alignment */}
          <p 
            className="text-xs md:text-sm uppercase font-medium text-[#F3E5CF]/90 mb-3"
            style={{ letterSpacing: '0.3em' }}
          >
            {t(tr.hero.location)}
          </p>
          
          {/* Date - subtle, refined */}
          <p 
            className="text-[10px] md:text-xs uppercase text-[#F3E5CF]/60"
            style={{ letterSpacing: '0.25em' }}
          >
            {t(tr.hero.date)}
          </p>
        </div>
      </section>
    </>
  );
};

export default CoconSacreHero;
